import { useEffect, useState } from 'react';
import constant from '../utils/constant';
import * as yup from 'yup';
import { removeEmptyKeys } from '../utils/utils';
import { StyleCatalogController } from '../controllers';
import { MimaToastUtil } from '../components';

const useContact = () => {
	const [loading, setLoading] = useState(false);

	const validationSchema = () =>
		yup.object({
			fullname: yup
				.string()
				.required('Full Name is required')
				.test('name', 'First and Last name is required', function (value) {
					const names = value ? value.split(' ') : [];
					return names.length > 1 && names[0].length > 1 && names[1].length > 1;
				}),
			email: yup
				.string()
				.trim()
				.email('Enter a valid Email')
				.required('Email Address is required'),
			message: yup.string().required('Message is required'),
			mobile: yup
				.string()
				.matches(/^[0-9]+$/, 'Phone number is not valid')
				.min(10, 'Phone number must be at least 10 digits')
				.max(15, 'Phone number cannot be longer than 15 digits')
				.optional(),
			business: yup.string().required('Business is required'),
		});

	const onSubmit = async (values, { resetForm }) => {
		setLoading(true);

		removeEmptyKeys(values);

		const { status, errorMessage } =
			await StyleCatalogController.sendContactMessage(values);
		if (status === constant.Success) {
			window.sendTrackingEvent(constant.events.lead, {
				lead_type: 'contact_form',
				email: values.email,
				name: values.fullname,
			});
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return resetForm();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	//Event tracker start
	useEffect(() => {
		window.sendTrackingEvent(constant.events.page_visit, {
			page_type: 'contact',
		});
	}, []);
	//Event tracker end

	return {
		validationSchema,
		onSubmit,
		loading,
	};
};

export default useContact;
